import { render } from "./YeasCard.vue?vue&type=template&id=0d347bbc&scoped=true"
const script = {}

import "./YeasCard.vue?vue&type=style&index=0&id=0d347bbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d347bbc"]])

export default __exports__